export default {
  className: '_User',
  fields: [
    {
      name: 'username',
      tooltip: '新创建管理员默认密码为123456',
      validators: [
        // 可以使用多个验证，依次执行，碰到第一个错误时停止验证
        (value) => value ? null : '不可为空'
      ]
    },
    'name',
    'avatar'
    // 'phone'
  ],
  search: [
    'username'
  ],
  action: {
    export: false,
    delete: {
      callback: async ({ record, vm, modelName }) => { // 点击按钮后触发的callback回调，参数中的 record代表被点击行的数据，vm为vue实例
        await vm.confirm('警告', '你确定要删除该管理员吗?')
        let rs = await vm.$modelAjax.delete(modelName, record.objectId).catch(() => {
          this.$notification['error']({
            message: '网络错误',
            description: '删除失败'
          })
        })
        if (rs) {
          vm.$notification['success']({
            message: '操作成功',
            description: '该管理员已被删除'
          })
          vm.refresh() // 你可以调用refresh与reset方法来刷新页面，区别为reset会重置查询条件，排序，翻页页数
        }
      }
    },
    reset: {
      type: 'row',
      text: '重置密码',
      callback: async ({ record, vm, className }) => {
        await vm.confirm('警告', `确定要重置${record.username}的密码吗?`)
        let data = {
          password: '123456'
        }
        let res = await vm.$tkParse.put(`/classes/_User/${record.objectId}`, data).catch((e) => {
          this.$notification['error']({
            message: '网络错误',
            description: '重置密码失败'
          })
          throw e
        })
        if (res) {
          vm.$notification['success']({
            message: '操作成功',
            description: '重置密码成功'
          })
          vm.refresh()
        }
      }
    }
  },
  hooks: {
    beforeFetch ({ where }) {
      // 查询管理员身份为平台管理员的用户
      where.adminRole = 'administrator'
    },
    beforeInsert ({ data }) {
      data.adminRole = 'administrator'
      data.password = '123456'
    }
  }
}
